import Card from 'components/card';
import { updateCustomerBlocked } from 'interfaces/customer';
import { useEffect, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

function CustomersOverCreditLimit(props: { data: any }) {
    const { data } = props;
    const navigate = useNavigate();
    const [rows, setRows] = useState<any[]>([]);
    const [blockingId, setBlockingId] = useState<string | null>(null);

    const canBlockCustomer = useMemo(() => {
        const storedPermissions = JSON.parse(
            localStorage.getItem('permissions') || '[]',
        ) as string[];
        const isOwner = !localStorage.getItem('ownerId');
        return (
            isOwner ||
            storedPermissions.includes('all') ||
            storedPermissions.includes('block:customers')
        );
    }, []);

    useEffect(() => {
        setRows(data || []);
    }, [data]);

    const handleBlock = async (customerId: string) => {
        setBlockingId(customerId);
        const res = await updateCustomerBlocked({
            _id: customerId,
            isBlocked: true,
        });
        if (res.data) {
            setRows((prev) => prev.filter((r) => r._id !== customerId));
            toast.success('Client bloqué de toutes commandes.');
        }
        setBlockingId(null);
    };

    return (
        <Card extra="px-[34px] pt-3 rounded-[20px] w-full border">
            <div className="flex items-center justify-between">
                <div>
                    <h4 className="ml-px text-lg font-bold text-navy-700 dark:text-white">
                        Créance dépassée
                    </h4>
                    <p className="mb-2">clients à bloquer</p>
                </div>
            </div>
            {rows.length === 0 && (
                <p className="mb-4 text-xs text-gray-500 dark:text-gray-400">
                    Aucun client ne dépasse sa créance possible.
                </p>
            )}
            {rows.slice(0, 5).map((item: any) => (
                <div
                    key={item._id}
                    className="mb-4 ml-1 flex items-center justify-between gap-3"
                >
                    <div
                        className="min-w-0 cursor-pointer"
                        onClick={() => navigate(`/customer/${item._id}`)}
                    >
                        <h5 className="truncate text-base font-bold text-navy-700 dark:text-white">
                            {item.company || item.displayName}
                        </h5>
                        <p className="text-xs font-medium text-gray-600 dark:text-gray-400">
                            {item.leftToPay?.toFixed(2)}€ dus / {item.creancePossible?.toFixed(2)}€
                            autorisés (+{item.overage?.toFixed(2)}€)
                        </p>
                    </div>
                    {canBlockCustomer && (
                        <button
                            type="button"
                            disabled={blockingId === item._id}
                            onClick={() => handleBlock(item._id)}
                            className="shrink-0 rounded-xl bg-red-600 px-3 py-1.5 text-xs font-semibold text-white transition-colors hover:bg-red-700 disabled:opacity-50"
                        >
                            {blockingId === item._id ? '...' : 'Bloquer'}
                        </button>
                    )}
                </div>
            ))}
        </Card>
    );
}

export default CustomersOverCreditLimit;
